export const SET_ROUTE = 'SET_ROUTE';
export const SET_DISP = 'SET_DISP';
export const SET_DATE = 'SET_DATE';
export const SET_NEW_DATE_DISP = 'SET_NEW_DATE_DISP';
export const SET_NEW_ROUTE_DISP = 'SET_NEW_ROUTE_DISP';
export const SET_FETCH_STATE = 'SET_FETCH_STATE';
export const SET_SERVICE_STATE = 'SET_SERVICE_STATE';
export const SET_LANGUAGE = 'SET_LANGUAGE';

export const setDisp = value => ({ type: SET_DISP, value });
export const setDateDisp = value => ({ type: SET_NEW_DATE_DISP, value });
export const setRouteDisp = value => ({ type: SET_NEW_ROUTE_DISP, value });
export const setFetchState = value => ({ type: SET_FETCH_STATE, value });
export const setServiceState = value => ({ type: SET_SERVICE_STATE, value });
export const setLanguage = value => ({ type: SET_LANGUAGE, value });
